/* eslint-disable linebreak-style */
import { defineMessages } from 'react-intl';

export default defineMessages({
  exploreSymptoms: {
    id: 'Explore Symptoms',
    defaultMessage: 'Explore Symptoms',
  }
});
